import React, { useEffect, useState } from "react";

import { Col, Row, Divider, Select, Input, DatePicker, message } from "antd";
import Title from "antd/es/skeleton/Title";
import dayjs from "dayjs";
import PropTypes from "prop-types";
import { describeFrecuency, describeNextFrecuencyDate } from "../DescribeFrecuency";

const optionsFrequency = [
	{
		value: "daily",
		label: "Diario",
	},
	{
		value: "weekly",
		label: "Semanal",
	},
	{
		value: "monthly",
		label: "Mensual",
	},
	{
		value: "yearly",
		label: "Anual",
	},
];

const planFrecuency = [
	{
		value: "first-each-month",
		label: "Primero de cada mes",
	},
	{
		value: "15-each-month",
		label: "15 de Cada mes",
	},
	{
		value: "final-each-month",
		label: "Finales de cada mes",
	},
	{
		value: "customized",
		label: "Personalizado",
	},
];

const frequencydLimit = {
	"daily" : {
		"limit" : 6,
		"recomendation": "Límite excedido: Porfavor selecciona la frecuencia semanal"
	},
	"weekly" : {
		"limit" : 4,
		"recomendation": "Límite excedido: Porfavor selecciona la frecuencia mensual"
	},
	"monthly" : {
		"limit" : 11,
		"recomendation": "Límite excedido: Porfavor selecciona la frecuencia anual"
	},
	"yearly" : {
		"limit" : 5,
		"recomendation": "¿Seguro que quieres dejar pasar mucho tiempo?"
	},
};

const validDate = (date) => dayjs(date).isValid() ? dayjs(date) : null;

export const FrequencyRules = ({recurrenceRules, onRecurrenceRules}) => {
	const [selectedPlan, setSelectedPlan] = useState(null);
	
	const disabledDate = (current) => {
		const dateCurrent = validDate(current);
		return dateCurrent && dateCurrent < dayjs().startOf("day");
	};

	useEffect(() => {
		if(recurrenceRules?.frequency !== "" && recurrenceRules.interval !== 0){
			setSelectedPlan("customized");
		}
	}, []);
	

	const selectPlan = (value) => {
		setSelectedPlan(value);
		const currentDate = dayjs();
		const endDate = validDate(recurrenceRules.end_date);

		if(value === "first-each-month"){
			const firstDayOfNextMonth = currentDate.add(1, "month").startOf("month");
			const newDate = {
				interval: 1, 
				frequency: "monthly", 
				start_date: firstDayOfNextMonth.format("YYYY-MM-DD"), 
				end_date: firstDayOfNextMonth.isAfter(endDate) ? null : recurrenceRules.end_date
			};
			onRecurrenceRules(newDate);
			return;
		}

		if(value === "15-each-month"){
			const nextFifteenth = currentDate.date() >= 15 ? currentDate.date(15).add(1, "month") 
				: dayjs(`${currentDate.year()}-${currentDate.month() + 1}-15`);

			const newDate = {
				interval: 1, 
				frequency: "monthly", 
				start_date: nextFifteenth.format("YYYY-MM-DD"), 
				end_date: nextFifteenth.isAfter(endDate) ? null : recurrenceRules.end_date
			};
			onRecurrenceRules(newDate);
			return;
		}

		if(value === "final-each-month"){
			const nextLastDay = currentDate.format("YYYY-MM-DD") === currentDate.endOf("month").format("YYYY-MM-DD") ? 
				currentDate.add(1, "day").endOf("month") : currentDate.endOf("month");
			
			const newDate = {
				interval: 1, 
				frequency: "monthly", 
				start_date: nextLastDay.format("YYYY-MM-DD"), 
				end_date: nextLastDay.isAfter(endDate) ? null : recurrenceRules.end_date
			};
			onRecurrenceRules(newDate);
			return;
		}	
	};

	const disabledDateForEnd = (current) => {
		const dateCurrent = validDate(current);
		const startDate = validDate(recurrenceRules.start_date);
		const minEndDate = startDate.add(7, "day");
		return dateCurrent && dateCurrent < minEndDate.startOf("day");
	};

	const changeFrequency = (value) => {
		const number = recurrenceRules?.interval;
		const { limit } = frequencydLimit[value];

		if(number > limit){
			onRecurrenceRules({interval: limit, frequency: value});
			return;
		}
		
		onRecurrenceRules({frequency: value});
	};

	const changeInterval = ({target}) => {
		if(!recurrenceRules?.frequency){
			message.warning("Porfavor inserta una frecuencia valida");
			return;
		}

		const { value }	= target;

		const number = parseInt(value);
		const { limit, recomendation } = frequencydLimit[recurrenceRules?.frequency];

		if(number > limit){
			message.info(recomendation);
			return;
		}
		
		onRecurrenceRules({interval: number});
	};

	return (
		<>
			<Divider orientation="center">Reglas Recurrencia</Divider>
			<h3 style={{ textAlign: "center" }}>Selecciona tipo de frecuencia: </h3>
			<Select
				placeholder="Selecciona Plan de Frecuencia..."
				options={planFrecuency}
				style={{
					width: "100%",
					marginTop: "5px",
					marginBottom: "5px",
				}}
				value={selectedPlan}
				onChange={selectPlan}
			/>
			{selectedPlan && <>
				<h3 style={{ textAlign: "center" }}>Configuracion Emisión de Facturas</h3>			
				<Row gutter={[50, 0]}>
					<Col span={12}>
						<h3 style={{ textAlign: "center" }}>Fecha de inicio: </h3>
						<DatePicker 
							style={{
								width: "100%",
								marginTop:"10px"
							}}
							value={recurrenceRules.start_date ? dayjs(recurrenceRules.start_date) : null}
							onChange={(_, dateString) => {								
								const newStartDate = validDate(dateString);
								const minEndDate = validDate(newStartDate.add(7, "day"));
								const endDate = validDate(recurrenceRules.end_date);
								
								if (minEndDate.isAfter(endDate)) {
									onRecurrenceRules({start_date: dateString, end_date: null});
									return;
								} 
								
								onRecurrenceRules({start_date: dateString});
							}}
							disabled={selectedPlan !== "customized"}
							disabledDate={disabledDate}
							status={!recurrenceRules?.start_date ? "error" : ""}
						/>
					</Col>
					<Col span={12}>
						<h3 style={{ textAlign: "center" }}>{"Fecha de finalización (Opcional):"} </h3>
						<DatePicker 
							style={{
								width: "100%",
								marginTop:"10px"
							}}
							value={validDate(recurrenceRules.end_date)}
							onChange={(_, dateString) => {
								const dateSelected = validDate(dateString);

								if(dateSelected === null) return;
								
								onRecurrenceRules({ end_date: dateString });
							}}
							disabledDate={disabledDateForEnd}
							disabled={!recurrenceRules?.start_date}
						/>
					</Col>
				</Row>
				<br/>			
				<Row gutter={[50, 0]}>
					<Col span={12}>
						<h3 style={{ textAlign: "center" }}>Frecuencia: </h3>
						<Select
							placeholder="Selecciona Tipo de Frecuencia..."
							options={optionsFrequency}
							style={{
								width: "100%",
								marginTop: "5px",
								marginBottom: "5px",
							}}							
							value={recurrenceRules.frequency}
							disabled={selectedPlan !== "customized"}
							onChange={changeFrequency}
							status={recurrenceRules?.frequency === "" || !recurrenceRules?.frequency ? "error" : "success"}
						/>
					</Col>
					<Col span={12}>
						<h3 style={{ textAlign: "center" }}>{"Intervalo(s):"}</h3>
						<Title level={5} style={{ margin: "0", padding: "0" }}>Tipo de DTE</Title>
						<Input
							type="number"
							placeholder="Cantidad"
							min={0}
							style={{
								width: "100%",
								marginTop: "5px",
								marginBottom: "5px",
							}}
							value={recurrenceRules.interval}
							disabled={selectedPlan !== "customized"}
							onChange={changeInterval}
							status={recurrenceRules.interval === 0 ? "error" : "success"}
						/>
					</Col>
				</Row>			
			</>}
			<h3 style={{ textAlign: "center" }}>{describeFrecuency(recurrenceRules.frequency || "", recurrenceRules.interval)}</h3>
			<h3 style={{ textAlign: "center" }}>{describeNextFrecuencyDate(recurrenceRules) ? `Fecha de emisión comenzará: ${describeNextFrecuencyDate(recurrenceRules)}` : ""}</h3>
			<h3 style={{ textAlign: "center" }}>Aviso: Las recurrencias se emiten a las 4 AM Hora GT</h3>
			<br/>							
		</>
	);
};

FrequencyRules.propTypes = {
	recurrenceRules: PropTypes.object.isRequired,
	onRecurrenceRules: PropTypes.func.isRequired,
};